import { render, staticRenderFns } from "./before-after-event.vue?vue&type=template&id=bfdc640a&"
import script from "./before-after-event.js?vue&type=script&lang=js&"
export * from "./before-after-event.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports